import { combineReducers } from 'redux'
import authReducers from './auth'
import stateReducers from './state'
import lgaReducers from './lga'

const rootReducer = combineReducers({
  auth: authReducers,
  state: stateReducers,
  lga: lgaReducers,
})

export default rootReducer
